import { useEffect, useState } from "react";
import Default from "./Default";
import LottiePlaceholder from "../components/UI/placeholders/LottiePlaceholder";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../store/actions/group.action";
import { useLocation } from "react-router-dom";
import WebSocket from "../components/WebSockets";
import { logout, setStorage } from "../services/localStorageService";

const DevicesNotFound = () => {
  const [status, setStatus] = useState(null);
  // const dispatch = useDispatch();

  // const showSidebar = useSelector((state) => state.groupReducer.showSidebar);
  const location = useLocation();

  useEffect(() => {
    setStatus(location.hash);
  }, []);

  // useEffect(() => {
  //   // hiding sidebar by default
  //   if (showSidebar) dispatch(toggleSidebar());
  // }, []);

  useEffect(() => {
    logout();
  }, []);

  const getImage = () => {
    if (status == "#no-devices") {
      return require("./../assets/img/new/no-devices.svg").default;
    } else {
      return require("./../assets/img/new/no-active-devices.svg").default;
    }
  };

  const getMessage = () => {
    if (status == "#no-devices") {
      return "The devices have not been installed yet. Please check back after our technicians have completed the installation";
    } else {
      return "Your devices have now been successfully installed. Please allow a short period of time for them to become fully activated and ready for use.";
    }
  };

  return (
    <main
      className="d-flex align-items-center justify-content-center "
      style={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <div
        style={{
          width: "90%",
          height: "90%",
          backgroundColor: "whitesmoke",
        }}
        className=" d-flex flex-column justify-content-center align-items-center"
      >
        <img
          src={getImage()}
          className="mt-6"
          width="40%"
          style={{ marginRight: "auto", marginLeft: "auto" }}
          height="auto"
        />
        <LottiePlaceholder className="mt-5" text={getMessage()} />
        <img
          src={require("./../assets/images/login-logo.png").default}
          className="mt-6"
          width="10%"
          style={{ marginRight: "auto", marginLeft: "auto" }}
          height="auto"
        />
      </div>
      <WebSocket />
    </main>
  );
};

export default DevicesNotFound;
